export type SessionId = string;
export type DocumentId = number;

export enum Lock {
  NO_LOCK = 'NO_LOCK',
  HAS_LOCK = 'HAS_LOCK',
}

export type RoomSessions = RoomSession[];

export interface RoomSession {
  sessionId: string;
  customerId: number;
  joinedAt: number;
  lock: Lock;
  /** A room might or might not have a document selected */
  documentId?: number;
}

export enum SocketState {
  CLOSED = 'closed',
  CONNECTING = 'connecting',
  OPEN = 'open',
}
